import Cookies from 'js-cookie';
import vars from '../../../../vars.js';

let technicalCookies = true;
let trackingCookies = true;
const googleAnalyticsID = vars.googleAnalyticsID;

const launchAnalytics = () => {
  // const script1 = document.createElement('script');
  // script1.type = 'text/javascript';
  // script1.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsID}`;
  // script1.async = '';

  const script2 = document.createElement('script');
  script2.type = 'text/javascript';
  script2.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${googleAnalyticsID}');`;

  //document.head.appendChild(script1);
  //document.head.appendChild(script2);
};

const setHideBannerCookie = () => {
  Cookies.set('hide-banner', true);
};

const CookiesBox = ((($) => {
  function init() {

    // Init at true
    $('#toggle-all').prop('checked', true);
    $('#toggle-all').parent().addClass('checked');
    technicalCookies = true;
    $('#technical').prop('checked', true);
    $('#technical').parent().addClass('checked');
    trackingCookies = true;
    $('#tracking').prop('checked', true);
    $('#tracking').parent().addClass('checked');


    $('#toggle-all').on('click', (e) => {
      if(!e.target.checked) {
        technicalCookies = true;
        $('#technical').prop('checked', true);
        $('#technical').parent().addClass('checked');
        trackingCookies = true;
        $('#tracking').prop('checked', true);
        $('#tracking').parent().addClass('checked');
      }
      else {
        technicalCookies = false;
        $('#technical').prop('checked', false);
        $('#technical').parent().removeClass('checked');
        trackingCookies = false;
        $('#tracking').prop('checked', false);
        $('#tracking').parent().removeClass('checked');
      }
    });

    $('#technical').on('click', (e) => {
      technicalCookies = !e.target.checked;
    });

    $('#tracking').on('click', (e) => {
      trackingCookies = !e.target.checked;
    });

    $('#cookies-nok').on('click', function(e) {
      e.preventDefault();
      technicalCookies = false;
      trackingCookies = false;
      $('#technical').prop('checked', false);
      $('#technical').parent().removeClass('checked');
      $('#tracking').prop('checked', false);
      $('#tracking').parent().removeClass('checked');
      $(this).parents('#cookiesbanner').fadeOut('fast');
    });

    $('#cookies-ok, #cookies-save').on('click', function(e) {
      e.preventDefault();
      $(this).parents('#cookiesbanner').fadeOut('fast');

      if (technicalCookies) {
        setHideBannerCookie();
      }

      if (trackingCookies) {
        launchAnalytics();
      }
      else if (technicalCookies) {
        $.cookie('no-analytics', true, {
          expires: 7,
          path: '/',
        });
      }
    });

    $('.expand-cookies').on('click', function() {
      $(this).toggleClass('active');
      $('.banner-cookies_expanded').toggleClass('visible');
    });

    if (!$.cookie('hide-banner')) {
      setTimeout(() => $('#cookiesbanner').css('display', 'block'), 1000);
    }
    else if (!$.cookie('no-analytics')) {
      launchAnalytics();
    }
  }

  return {
    init,
  };
}))(jQuery);

export default CookiesBox;



// WEBPACK FOOTER //
// ./src/static/js/modules/cookies.js